import { AccessToken } from "../../store/token/TokenSlice";
import { configureAccessToken } from "./accessTokenUrl";

export { configureAccessToken, extractAccessTokenFromWindowLocation } from "./accessTokenUrl";

export type StorageUtil = {
  discardAccessToken: () => void;
  getAccessToken: () => string;
  hasAccessToken: () => void;
  saveAccessToken: (token: AccessToken) => void;
};

export const configureStorage = () => {
  let storedAccessToken: AccessToken;
  return {
    discardAccessToken: () => {
      storedAccessToken = null;
    },
    getAccessToken: () => storedAccessToken,
    hasAccessToken: () => Boolean(storedAccessToken),
    saveAccessToken: (token: AccessToken) => {
      storedAccessToken = token;
    },
  } as StorageUtil;
};

export const accessToken = configureAccessToken(window, configureStorage());
